import { User } from './../model/user.model';
import { UserResponse } from './../model/userResponse.model';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url = environment.baseUrl

  constructor(private http: HttpClient) { }

  Autenticar(token: any): Observable<Object> {
    let tokenJson = new HttpParams().set('token', token);
    return this.http.get(`${this.url}validatoken`, { params: tokenJson, withCredentials: true });
  }
}
